import { render } from "./LogicalMemory.vue?vue&type=template&id=653afb74&scoped=true"
import script from "./LogicalMemory.vue?vue&type=script&lang=js"
export * from "./LogicalMemory.vue?vue&type=script&lang=js"

import "./LogicalMemory.vue?vue&type=style&index=0&id=653afb74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653afb74"]])

export default __exports__